import React from 'react';
import clsx from 'clsx';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || '?';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const colors = [
  'bg-[var(--primary)]',
  'bg-[var(--accent)]',
  'bg-[var(--info)]',
  'bg-[var(--clay)]',
  'bg-[var(--earth)]',
];

const getColorIndex = (name) => {
  if (!name) return 0;
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % colors.length;
};

export const Avatar = ({ name, size = 'md', className, ...props }) => {
  const sizes = {
    sm: 'w-7 h-7 text-xs',
    md: 'w-9 h-9 text-sm',
    lg: 'w-11 h-11 text-base',
  };
  
  const colorClass = colors[getColorIndex(name)];
  
  return (
    <div
      className={clsx(
        'rounded-full flex items-center justify-center text-white font-medium ring-2 ring-white',
        colorClass,
        sizes[size],
        className
      )}
      title={name}
      data-testid={props['data-testid'] || 'avatar'}
      {...props}
    >
      {getInitials(name)}
    </div>
  );
};

export const AvatarStack = ({ users = [], max = 4, className }) => {
  const visible = users.slice(0, max);
  const remaining = users.length - max;
  
  return (
    <div className={clsx('flex -space-x-2', className)} data-testid="avatar-stack">
      {visible.map((user, i) => (
        <Avatar key={user} name={user} size="sm" />
      ))}
      {remaining > 0 && (
        <div className="w-7 h-7 rounded-full bg-[var(--muted)] flex items-center justify-center text-xs font-medium text-[var(--fg)] ring-2 ring-white">
          +{remaining}
        </div>
      )}
    </div>
  );
};